import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(
  LineController, LineElement, PointElement,
  LinearScale, CategoryScale,
  Tooltip, Legend,
)

export default class extends Controller {
  static values = {
    labels: Array,
    account: Array,
    voucher: Array,
    accountLabel: { type: String, default: "Account credits" },
    voucherLabel: { type: String, default: "Voucher credits" },
  }

  connect() {
    const canvas = this.element.querySelector("canvas") || this.element

    this.chart = new Chart(canvas.getContext("2d"), {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: this.accountLabelValue,
            data: this.accountValue,
            borderColor: "#3b82f6",
            backgroundColor: "#3b82f620",
            borderWidth: 2,
            fill: false,
            tension: 0.2,
            pointRadius: 4,
            pointBackgroundColor: "#3b82f6",
            pointBorderColor: "#fff",
            pointBorderWidth: 1,
          },
          {
            label: this.voucherLabelValue,
            data: this.voucherValue,
            borderColor: "#f59e0b",
            backgroundColor: "#f59e0b20",
            borderWidth: 2,
            fill: false,
            tension: 0.2,
            pointRadius: 4,
            pointBackgroundColor: "#f59e0b",
            pointBorderColor: "#fff",
            pointBorderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          legend: { position: "top" },
          tooltip: { mode: "index", intersect: false },
        },
        scales: {
          x: {
            ticks: { maxRotation: 45, autoSkip: true },
          },
          y: {
            beginAtZero: true,
            ticks: { stepSize: 1 },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
